// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"882":"357423fb","900":"4851079e"}[chunkId] + ".chunk.css";
};